import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpOptions = {
    headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Accept',

        'Access-Control-Allow-Credentials': 'true',
        'Content-Type': 'application/json'
    })
};

const httpGetOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    }),
    withCredentials: true
};

const httpPostOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    }),
    withCredentials: true
};

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RequestOptions, ResponseContentType, Request, RequestMethod, ResponseType } from '@angular/http';
import { MessageService } from './message.service';
import { CpiHeader } from '../model/CPI';

@Injectable({
    providedIn: 'root'
})

export class InspectionService {
    private apiEndpoint = environment.apiEndpoint;
    private inspectionUrl = this.apiEndpoint + 'CPI';
    private ExportUrl = this.apiEndpoint + 'Export';

    constructor(private http: HttpClient,
        private messageService: MessageService) {
    }

    getCPIList(): Observable<CpiHeader[]> {
        //console.log('URL: ' + this.inspectionUrl);
        console.log('URL: ' + this.inspectionUrl + '/GetCPIHeaderList/' + 'null');
        //console.log('List: ' + this.http.get<CpiHeader[]>(this.inspectionUrl + '/GetCPIList/' + '2018-07-07', httpOptions));
        return this.http.get<CpiHeader[]>(this.inspectionUrl + '/GetCPIHeaderList/' + 'null' + '/null', httpGetOptions)
        // .pipe(
        //     tap(families => this.log(`fetched staffs`)),
        //     catchError(this.handleError('getStaffs', []))
        //   );
    }

    downloadCPIList(fromDate, toDate): Observable<Blob> {
        //let options = new RequestOptions({responseType: ResponseContentType.Blob });
        //return this.http.get(this.ExportUrl + '/DownloadInspectionExcel/' + id, options)
        //return this.http.get(this.ExportUrl + '/DownloadCPIHeaderExcel/' + 'null' + '/null', { responseType: 'blob' })
        return this.http.get(this.ExportUrl + '/DownloadCPIHeaderExcel/' + fromDate + '/' + toDate, {
            headers: httpGetOptions.headers,
            withCredentials: true,
            responseType: 'blob'
        })
        //.map(res => res.blob())
        //.catch(this.handleError)
    }

    downloadReport(id): Observable<Blob> {
        //let options = new RequestOptions({responseType: ResponseContentType.Blob });
        //return this.http.get(this.ExportUrl + '/DownloadInspectionExcel/' + id, options)
        return this.http.get(this.ExportUrl + '/DownloadInspectionExcel/' + id, { responseType: 'blob' })
        //.map(res => res.blob())
        //.catch(this.handleError)
    }

    getCPIListByInspectionDate(inspectionDateFrom, inspectionDateTo): Observable<CpiHeader[]> {
        return this.http.get<CpiHeader[]>(this.inspectionUrl + '/GetCPIHeaderList/' + inspectionDateFrom + '/' + inspectionDateTo, httpGetOptions)
    }

    getCPIImageList(id): Observable<any> {
        return this.http.get(this.inspectionUrl + '/GetCPIPhotoList/' + id, { responseType: 'json' })
    }

    getCPIImageListByHeaderList(idList): Observable<any> {
        return this.http.get(this.inspectionUrl + '/GetCPIPhotoListByHeaderList/' + idList, { responseType: 'json' })
    }

    getCPIImage(id, name): Observable<any> {
        return this.http.get(this.inspectionUrl + '/GetCpiImage/' + id + '/' + name, { responseType: 'json' })
    }
}